export function About() {
  return (
    <p>
      Runze is a fashion photographer living in Brooklyn, NY. 
    </p>
  );
}
